<template>
    <div class="message-container">
    <!-- <van-empty v-if="list.length==0" description="暂无消息" />
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
    > -->
            <van-cell center title="工作流" @click="golist1">
                <template #icon>
                    <!-- <van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png" size="40"/> -->
                    <div class="message-workflow-icon-wrap" style="background: #0078d7;">
                        <van-icon class-prefix="cgsIcon" name="gongzuoliuchengtu" class="iconfont message-workflow-icon"/>
                    </div>
                    
                </template>
                <template #right-icon>
                    <van-badge :content="content" v-show="content!=0" style="margin-top: 22px;">
                    <div class="child" />
                    </van-badge>
                </template>
            </van-cell>
            <van-cell center title="应用">
                <template #icon>
                    
                    <div class="message-workflow-icon-wrap" style="background: #fb9320;">
                        <van-icon class-prefix="cgsIcon" name="yingyongzhongxin" class="iconfont message-workflow-icon"/>
                    </div>
                </template>
                <template #right-icon>
                    <van-badge  v-show="content!=0">
                    <div class="child" />
                    </van-badge>
                </template>
            </van-cell>
            <van-cell center title="系统">
                <template #icon>
                    <div class="message-workflow-icon-wrap" style="background: #96a8a5;">
                        <van-icon class-prefix="cgsIcon" name="tongzhifill" class="iconfont message-workflow-icon"/>
                    </div>
                </template>
                <template #right-icon>
                    <van-badge  v-show="content!=0">
                    <div class="child" />
                    </van-badge>
                </template>
            </van-cell>
        <!-- <van-cell-group v-for="item in list" :key="item.notice_id">
            <van-cell center :label="item.createTime">
                <template #title class="cell">
                    <van-badge dot v-show="item.is_fav==false">
                        <div class="child" />
                    </van-badge>
                    <span @click="workflowInstanceClick(item.msg)" v-html="item.msg"></span>
                </template>
            </van-cell>
        </van-cell-group> -->
    <!-- </van-list> -->
    </div>
</template>

<script>
import { List,Cell,CellGroup,Empty,Badge,Icon  } from 'vant';
import { NumberMessage,NumberMessageClear } from '@/api/message';
export default {
    components: {
      vanList:List,
      vanCell:Cell,
      vanCellGroup:CellGroup,
      vanEmpty:Empty,
      vanBadge:Badge,
      vanIcon:Icon, 
    },
    data () {
        return {
            content:'',
        }
    },
    methods: {
        async golist1(){  
            this.$router.push('/messagelist1')
            await NumberMessageClear('1')
        },
        async Numberage(){
            let nage = await NumberMessage()
            this.content = nage.data[1].notice_total
        }
    },
    created () {
        this.Numberage()
        this.$ws.on('send_notice', async (data) => {
                let noticeCount = await NumberMessage()
                // this.noticeCount = noticeCount
                this.content = noticeCount.data[1].notice_total
        })
        this.$ws.on('clear_notice', async (data) => {
                let noticeCount = await NumberMessage()
                // this.noticeCount = noticeCount
                this.content = noticeCount.data[1].notice_total
        })
    }

}
</script>
<style scoped>
.message-workflow-icon-wrap{
    width: 40px;
    height:40px;
    border-radius: 50%;
    text-align: center;
    margin-right: 10px;
}
.message-workflow-icon{
    font-size: 25px;
    color: #fff;
    line-height:40px;
}
/* .cell{
    height: 80px;
    border-bottom: 1px solid #cfcfcf;
    border-top: 1px solid #cfcfcf;
} */
    .child {
    width: 20px;
    height: 20px;
    /* background: #f2f3f5; */
    border-radius: 4px;
  }
</style>